import {
  TBH_EMPLOYEE_MANAGEMENT,
  TBH_EMPLOYEE_MANAGEMENT_CREATE,
  TBH_EMPLOYEE_MANAGEMENT_FILTERS,
} from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const jsonHeaders = { 'content-type': 'application/json' };

export const tbhEmployeeManagementFilters = () => ({
  url: `${TBH_EMPLOYEE_MANAGEMENT_FILTERS}?cb=${Date.now()}`,
  method: 'get',
  headers: jsonHeaders,
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const createTbhEmployeeManagement = (payload) => ({
  url: TBH_EMPLOYEE_MANAGEMENT_CREATE,
  method: 'post',
  headers: jsonHeaders,
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.LANDING_MS,
});

export const updateTbhEmployeeManagement = (id, payload) => ({
  url: `${TBH_EMPLOYEE_MANAGEMENT}/${id}`,
  method: 'put',
  headers: jsonHeaders,
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.LANDING_MS,
});

export const deleteTbhEmployeeManagement = (id) => ({
  url: `${TBH_EMPLOYEE_MANAGEMENT}/${id}`,
  method: 'delete',
  headers: jsonHeaders,
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getTbhDetailsByTbhId = (tbhId) => ({
  url: `${TBH_EMPLOYEE_MANAGEMENT}/tbh/${tbhId}`,
  method: 'get',
  headers: jsonHeaders,
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});
